<div class="info-line work-time">
    <div class="info">
        <h2>{{title|translate}}</h2>
        <div style="overflow-x:revert;">
            <table class="table">
                <tr>
                    <th *ngFor="let item of countedWorkTime"><a style="cursor: pointer;"
                                                                (click)="showWorkTimeDetailsDialog(user, item.detailsDate)">{{item.date}}</a>
                    </th>
                </tr>
                <tr>
                    <td *ngFor="let item of countedWorkTime">{{item.timeInString}}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
